import { sibaBackendApi, sibaAuthApi, sibagenGlobalSetupApi, sibaCommunicationApi, sibaExceptionLogApi, sibaDocumentApi, sibaReportApi } from "../services/backends/sibaApis";

/***
 * Services reducer object will contain services.
 * which makes the code more readable intead of listing them
 * directly in configure store.
 */
const serviceReducers = {
    [sibaBackendApi.reducerPath]: sibaBackendApi.reducer,
    [sibaAuthApi.reducerPath]: sibaAuthApi.reducer,
    [sibagenGlobalSetupApi.reducerPath]: sibagenGlobalSetupApi.reducer,
    [sibagenGlobalSetupApi.reducerPath]: sibagenGlobalSetupApi.reducer,
    [sibaCommunicationApi.reducerPath]: sibaCommunicationApi.reducer,
    [sibaExceptionLogApi.reducerPath]: sibaExceptionLogApi.reducer,
    [sibaDocumentApi.reducerPath]: sibaDocumentApi.reducer,
    [sibaReportApi.reducerPath]: sibaReportApi.reducer
};

export default serviceReducers;
